<script>
import CandidateImage from '@/components/candidate/candidate-image.vue'
import accessibleNavigationMixin from '@/mixins/accessibleNavigationMixin'
import candidateMixin from '@/mixins/candidateMixin'
import VuetifyColourClass from '@/shared/constants/core/VuetifyColourClass'
import VuetifyTextClass from '@/shared/constants/core/VuetifyTextClass'

export default {
  name: 'CandidateCard',
  components: { CandidateImage },
  mixins: [candidateMixin, accessibleNavigationMixin],
  props: {
    candidate: {
      type: Object,
      required: true,
    },
    tabindex: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      VuetifyColourClass,
      VuetifyTextClass,
    }
  },
  computed: {
    fullName() {
      return `${this.candidate.firstName} ${this.candidate.lastName}`.trim()
    },
    isPreferred() {
      return (this.candidate.preferredLevels?.length ?? 0) > 0
    },
    preferredCount() {
      return (this.candidate.preferredLevels ?? []).reduce(
        (sum, level) => sum + (level?.linkCount ?? 0),
        0
      )
    },
    ariaLabel() {
      return this.$t('candidateList.card.viewProfileAriaLabel', {
        name: this.fullName,
      })
    },
    starIconColor() {
      return this.isPreferred
        ? VuetifyColourClass.warning400
        : VuetifyColourClass.grey400
    },
  },
  methods: {
    viewCandidateDetails() {
      this.$emit('view-candidate', this.candidate.candidateId)
    },
  },
}
</script>

<template>
  <v-card
    class="candidate-card custom-elevation d-flex rounded-lg"
    elevation="0"
    height="100%"
    role="button"
    :aria-label="ariaLabel"
    :tabindex="tabindex"
    @click="viewCandidateDetails"
    @keydown="onAccNavActionKeydown($event, viewCandidateDetails)"
  >
    <v-card-text class="d-flex pa-4">
      <div class="candidate-card__avatar-slot flex-shrink-0 mr-4">
        <v-lazy>
          <CandidateImage
            :id="candidate.candidateId"
            :first-name="candidate.firstName"
            :last-name="candidate.lastName"
            size="90"
            :font-size="22"
            rounded
          />
        </v-lazy>
      </div>

      <div class="flex-grow-1 candidate-card__body">
        <div class="d-flex align-start">
          <h4
            class="candidate-card__name flex-grow-1 ma-0"
            :class="VuetifyTextClass.smallBodyBold"
          >
            {{ fullName }}
          </h4>
          <v-icon
            :color="starIconColor"
            size="22"
            class="candidate-card__star ml-2 flex-shrink-0"
          >
            {{ isPreferred ? 'mdi-star' : 'mdi-star-outline' }}
          </v-icon>
        </div>

        <div :class="[VuetifyTextClass.smallBody, 'candidate-card__line']">
          {{
            $t('candidateList.card.bookingCount', {
              count: candidate.numberOfBookings,
            })
          }}
        </div>
        <div :class="[VuetifyTextClass.smallBody, 'candidate-card__line']">
          {{
            $t('candidateList.card.lastBooking', {
              date: displayDate(candidate.mostRecentBookingDateLocal),
            })
          }}
        </div>
        <div :class="[VuetifyTextClass.smallBody, 'candidate-card__line']">
          {{
            $t('candidateList.card.preferredBy', {
              count: preferredCount,
            })
          }}
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss" src="@/styles/candidate/candidate-card.scss"></style>
